import React, { useState, useEffect } from "react";
import TableTree, { Cell, Header, Headers, Row, Rows } from "@atlaskit/table-tree";
import ScriptVariableValue from "./ScriptVariableValue";
import ScriptedNameTextField from "./ScriptedNameTextField";
import ScriptVariableDeleteButton from "./ScriptVariableDeleteButton";
import uuid from "react-uuid";
import EmptyState from "@atlaskit/empty-state";
import TestScriptButton from "./TestScriptButton";
import ScriptVariableOptions from "./ScriptVariableOptions";
const ScriptVariableTable = ({ action, updated }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (action && action.scriptedVariables) {
      setRows(getRows());
    } else {
      setRows([]);
    }
  }, [action, updated]);
  const onRemoveScript = () => {
    setRows(getRows());
  };

  const createRow = (script, index) => ({
    id: uuid(),
    variableName: <ScriptedNameTextField scriptedVariable={script} />,
    action: (
      <>
        <ScriptVariableOptions scriptedVariable={script} />
        <TestScriptButton action={action} scriptItem={script} />
        <ScriptVariableDeleteButton action={action} uuid={script.uuid} callback={onRemoveScript} />
      </>
    ),
    hasChildren: true,
    isScript: false,
    children: [
      {
        id: uuid(),
        isScript: true,
        variableName: <ScriptVariableValue scriptedVariable={script} />,
        hasChildren: false,
      },
    ],
  });

  const getRows = () => {
    if (action && action.scriptedVariables) {
      return action.scriptedVariables.map((h, i) => {
        // console.log("NAME");
        return createRow(h, i);
      });
    }
    return [];
  };

  return (
    <>
      <TableTree>
        <Headers>
          <Header with="80%">Variable Name</Header>
          <Header with="20%">Action</Header>
        </Headers>
        <Rows
          items={rows}
          render={({ variableName, action, children, isScript = [] }) =>
            isScript ? (
              <>{variableName}</>
            ) : (
              <Row itemId={variableName} items={children} hasChildren={children.length > 0} isDefaultExpanded>
                <Cell width="80%" singleLine>
                  {variableName}
                </Cell>
                <Cell width="20%" singleLine>
                  {action}
                </Cell>
              </Row>
            )
          }
        />
      </TableTree>
      {rows.length === 0 && <EmptyState description="There is no scripted variables defined yet." />}
    </>
  );
};

export default ScriptVariableTable;
